import { TranslateHelper } from '@app/_helpers';
import { Component, Input, OnInit } from '@angular/core';
import { Product } from '@interfaces/product';
import { RootService } from '@services/root.service';
import { TranslateModule } from '@ngx-translate/core';
import { CurrencyFormatPipe } from '../../shared/pipes/currency-format.pipe';
import { RouterLink } from '@angular/router';
import { NgFor, NgIf } from '@angular/common';

@Component({
    selector: 'app-widget-products',
    templateUrl: './widget-products.component.html',
    styleUrls: ['./widget-products.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgFor, RouterLink, NgIf, CurrencyFormatPipe, TranslateModule]
})
export class WidgetProductsComponent implements OnInit {
    @Input() header = '';
    @Input() products: any[] = [];

    constructor(public translateHlper: TranslateHelper) {

    }
    ngOnInit(): void {
        this.products.forEach((product) => {
            product.images.url = this.imageUrl(product.images);
        });
    }

    imageUrl(imagesObject) {
        let image = 'assets/images/nologo.png';
        if (imagesObject) {
            let imageKey = Object.keys(imagesObject)[0]?.toString();
            image = imagesObject?.[imageKey]?.thumb?.url || (imagesObject[imageKey]?.url || 'assets/images/nologo.png');
        }
        return image;
    }
}
